var map = {
	"../articles/articles.module": [
		"./src/app/pages/articles/articles.module.ts",
		"default~articles-articles-module~pages-home-home-module~profile-profile-module",
		"default~articles-articles-module~pages-home-home-module"
	],
	"../stories/stories.module": [
		"./src/app/pages/stories/stories.module.ts",
		"stories-stories-module"
	],
	"./logs/logs.module": [
		"./src/app/pages/learn/logs/logs.module.ts",
		"logs-logs-module"
	],
	"./pages/account/account.module": [
		"./src/app/pages/account/account.module.ts",
		"common",
		"pages-account-account-module"
	],
	"./pages/article/article.module": [
		"./src/app/pages/article/article.module.ts",
		"pages-article-article-module"
	],
	"./pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"default~articles-articles-module~pages-home-home-module~profile-profile-module",
		"default~articles-articles-module~pages-home-home-module",
		"default~pages-home-home-module~profile-profile-module",
		"pages-home-home-module"
	],
	"./pages/landing/landing.module": [
		"./src/app/pages/landing/landing.module.ts",
		"pages-landing-landing-module"
	],
	"./pages/learn/learn.module": [
		"./src/app/pages/learn/learn.module.ts",
		"common",
		"pages-learn-learn-module"
	],
	"./pages/settings/settings.module": [
		"./src/app/pages/settings/settings.module.ts",
		"pages-settings-settings-module"
	],
	"./pages/story/story.module": [
		"./src/app/pages/story/story.module.ts",
		"pages-story-story-module"
	],
	"./profile/profile.module": [
		"./src/app/pages/account/profile/profile.module.ts",
		"default~articles-articles-module~pages-home-home-module~profile-profile-module",
		"default~pages-home-home-module~profile-profile-module"
	],
	"./reset-password/reset-password.module": [
		"./src/app/pages/account/reset-password/reset-password.module.ts",
		"reset-password-reset-password-module"
	],
	"./signin/signin.module": [
		"./src/app/pages/account/signin/signin.module.ts",
		"signin-signin-module"
	],
	"./signup/signup.module": [
		"./src/app/pages/account/signup/signup.module.ts",
		"signup-signup-module"
	],
	"./word/word.module": [
		"./src/app/pages/learn/word/word.module.ts",
		"word-word-module"
	],
	"./wordlist/wordlist.module": [
		"./src/app/pages/learn/wordlist/wordlist.module.ts",
		"wordlist-wordlist-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;